/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IDigiconModalScope extends ng.IScope {
        digicon: Models.Digicon;
        duplicate: boolean;
        roles: string[];
        roleSelected: string;
        modes: string[];
        modeSelected: string;
        kitSelected: string;
        matchNumbers: string[];
        matchNumberSelected: string;
        matchDays: string[];
        matchDaySelected: string;
        mainGateways: String[];
        backupGateways: String[];
        kits: String[];
        mainGatewaySelected: string;
        backupGatewaySelected: string;
        ports: string[];
        portSelected: string;
        isNewDigicon: boolean;
        loadDigicon:  boolean;
        digiconRoleChanged: (newValue: string) => void;
        digiconMainGatewayChanged: (newValue: string) => void;
        digiconBackupGatewayChanged: (newValue: string) => void;
        digiconModeChanged: (newValue: string) => void;
        digiconMatchDayChanged: (newValue: string) => void;
        digiconMatchNumberChanged: (newValue: number) => void;
        digiconPortChanged: (newValue: string) => void;
        kitChanged: (newValue: string) => void;
        checkDuplicate: () => boolean;


        modalClose: () => void;
        modalSave: () => void;
        init: () => void;

    }

    /**
     * DigiconModalController class
     */
    export class DigiconModalController {
        public static templateUrl: string = "decorators/modals/digicon-modal.html";
        public static ID: string = "#id-digicon-modal";
        public static $name: string = "digiconModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'digicon', 'duplicate', 'digiconService'];

        /**
         * Constructor
         */

        constructor(private $scope: IDigiconModalScope,
                    private close: (parameters: ngModal.ICloseParameters) => void,
                    private $timeout: ng.ITimeoutService,
                    private digicon: Models.Digicon,
                    private duplicate: boolean,
                    private digiconService: Services.DigiconService) {
            this.$scope.init = async () => {
                this.$scope.loadDigicon = true;
                // init selected default values in the modal and the lists of values
                this.$scope.roleSelected = "Select a role";
                this.$scope.mainGatewaySelected = "None";
                this.$scope.backupGatewaySelected = "None";
                this.$scope.roles =  ["Select a role", "Main", "Backup"];
                this.$scope.modeSelected = "Select a mode";
                this.$scope.kitSelected = "Select a kit";
                this.$scope.modes =  ["Select a mode", "Satellite", "Fiber"];
                this.$scope.matchNumberSelected = "Select a match Number";
                this.$scope.matchNumbers =  ["Select a match Number", "1", "2", "3", "4", "5", "6", "7", "8","9", "10", "11", "12"];
                this.$scope.matchDaySelected = "Select a match day";
                this.$scope.portSelected = "Select a port type";
                this.$scope.ports =  ["Select a port type", "Telco 1 Electrical", "Telco 1 Optical", "Telco 2 Electrical", "Telco 2 Optical"];
                this.$scope.matchDays =  ["Select a match day", "Tuesday", "Wednesday"];
                this.$scope.mainGateways =  ["None"];
                this.$scope.backupGateways =  ["None"];
                this.$scope.kits =  ["Select a kit"];
                this.$scope.isNewDigicon = (digicon === undefined || digicon.kit === undefined);
                this.close = close;
                if (this.$scope.isNewDigicon) {
                    this.$scope.digicon = Models.Digicon.Empty();
                }
                else {
                    this.$scope.modes.shift();
                    this.$scope.matchNumbers.shift();
                    this.$scope.matchDays.shift();
                    this.$scope.roles.shift();
                    this.$scope.ports.shift();

                    this.$scope.mainGateways = this.$scope.mainGateways.concat(digicon.mainGateway);
                    this.$scope.backupGateways = this.$scope.backupGateways.concat(digicon.backupGateway);
                    this.$scope.kitSelected = digicon.kit.toString();
                    this.$scope.digicon = digicon;
                    this.$scope.modeSelected = digicon.mode;
                    this.$scope.matchNumberSelected = digicon.matchNumber.toString();
                    this.$scope.roleSelected = digicon.role;
                    this.$scope.matchDaySelected = digicon.matchDay;
                    this.$scope.portSelected = digicon.port;
                    this.$scope.kitSelected = digicon.kit.toString();
                    // if duplicate reset gateways
                    if (duplicate) {
                        this.$scope.kits = ["Select a kit"];
                        this.$scope.kitSelected = "Select a kit";
                        this.$scope.digicon.kit = undefined;
                        this.$scope.mainGatewaySelected = 'None';
                        this.$scope.backupGatewaySelected = 'None';
                        digicon.mainGateway = 'None';
                        digicon.backupGateway = 'None';
                    }
                    else {
                        this.$scope.kits = [digicon.kit.toString()];
                        this.$scope.mainGatewaySelected = digicon.mainGateway;
                        this.$scope.backupGatewaySelected = digicon.backupGateway;
                    }
                }
                // load the gateways from the API
                let mainGateways: String[] = await this.digiconService.getMainGatewaysAvailable();
                let backupGateways: String[] = await this.digiconService.getBackupGatewaysAvailable();
                this.$scope.mainGateways = this.$scope.mainGateways.concat(mainGateways);
                this.$scope.backupGateways = this.$scope.backupGateways.concat(backupGateways);
                let kits: String[] = await this.digiconService.getKitsAvailable();
                this.$scope.kits = this.$scope.kits.concat(kits);
                this.$scope.loadDigicon = false;
                $timeout(() => {
                    window.altair_admin_common_init();
                    window.altair_forms_validation();
                }, 500);

            };

            this.$scope.init();

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.digicon.role !== undefined &&  this.$scope.digicon.role !== ''
                    && this.$scope.digicon.mode !== undefined &&  this.$scope.digicon.mode !== ''
                    && this.$scope.digicon.matchNumber !== undefined &&  this.$scope.digicon.matchNumber !== undefined
                    && this.$scope.digicon.matchDay !== undefined &&  this.$scope.digicon.matchDay !== ''
                    && this.$scope.digicon.port !== undefined &&  this.$scope.digicon.port !== ''
                    && this.$scope.digicon.kit !== undefined &&  this.$scope.digicon.kit !== undefined) {
                    this.close(this.$scope.digicon);
                }
            };

            this.$scope.digiconRoleChanged = (newValue: string) => {
                this.$scope.digicon.role = newValue;
            };

            this.$scope.digiconModeChanged = (newValue: string) => {
                this.$scope.digicon.mode = newValue;

            };

            this.$scope.digiconMatchDayChanged = (newValue: string) => {
                this.$scope.digicon.matchDay = newValue;
            };

            this.$scope.digiconMatchNumberChanged = (newValue: number) => {
                this.$scope.digicon.matchNumber = newValue;
            };

            this.$scope.digiconPortChanged = (newValue: string) => {
                this.$scope.digicon.port = newValue;
            };

            this.$scope.digiconMainGatewayChanged = (newValue: string) => {
                this.$scope.digicon.mainGateway = newValue;
            };

            this.$scope.checkDuplicate = () => {
                return duplicate;
            };

            this.$scope.digiconBackupGatewayChanged = (newValue: string) => {
                this.$scope.digicon.backupGateway = newValue;
            };

            this.$scope.kitChanged = (newValue: string) => {
                this.$scope.digicon.kit = Number(newValue);
            };
        }

    }
}
